const DECRYPT_KEY = process.env.REACT_APP_STC_SECURITY_KEY || '';
const IV_KEY = process.env.REACT_APP_STC_IV_KEY || '';

export async function decryptSTCResponse(
  encryptedData: string,
  withBase64Decoding = false
): Promise<string> {
  try {
    const subtle = globalThis.crypto?.subtle;

    if (!subtle) {
      console.error(new Error('Web Crypto API (subtle) is not available'));
      return '';
    }
    if (!DECRYPT_KEY || !IV_KEY || !encryptedData) {
      return '';
    }

    const keyBytes = new TextEncoder().encode(DECRYPT_KEY.slice(0, 16));
    if (keyBytes.byteLength !== 16) {
      console.error(
        new Error(
          'REACT_APP_STC_SECURITY_KEY: first 16 characters must encode to exactly 16 UTF-8 bytes'
        )
      );
      return '';
    }

    const iv = new Uint8Array(Buffer.from(IV_KEY, 'hex'));
    if (iv.byteLength !== 16) {
      console.error(new Error('REACT_APP_STC_IV_KEY must decode to 16 bytes (32 hex digits)'));
      return '';
    }

    const ciphertext = new Uint8Array(Buffer.from(encryptedData, 'base64'));

    const cryptoKey = await subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-CBC', length: 128 },
      false,
      ['decrypt']
    );

    const plainBuf = await subtle.decrypt({ name: 'AES-CBC', iv }, cryptoKey, ciphertext);

    let decrypted = new TextDecoder().decode(plainBuf);
    if (withBase64Decoding) {
      decrypted = Buffer.from(decrypted, 'base64').toString('utf8');
    }

    return decrypted;
  } catch (error) {
    console.error(error);
    return '';
  }
}
